module.exports = __webpack_public_path__ + "img/hot_icon1.9a8230b8.png";